import { Component } from '@angular/core';
import { environment } from '../../environments/environment';

@Component({
    selector: 'footer',
    templateUrl: './footer.html',
    standalone: true,
})
export class FooterComponent {
    currYear: number = new Date().getFullYear();
    appName: string = environment.appName;
    constructor() {}
    ngOnInit() {}
}
